module.exports = __webpack_public_path__ + "static/media/color_bath.ff48837c.svg";